module.exports = __webpack_public_path__ + "img/cool-to-dry.e938c453.svg";